import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import {
  FormInterface,
  FormSubentityInterface,
} from 'src/shared/types/entities/form-interface'

export const useUpdateFormSubentityProp = <
  Subentity extends FormSubentityInterface,
  Key extends keyof Subentity,
>(
  formEntity: FormInterface,
  updatedSubentity: Subentity,
) => {
  const updateEntity = useUpdateEntity<FormInterface>()

  return (prop: Key) => (value: Subentity[Key]) => {
    updateEntity({
      ...formEntity,
      subEntities: formEntity.subEntities.map(subentity =>
        subentity.id === updatedSubentity.id
          ? { ...subentity, [prop]: value }
          : subentity,
      ),
    })
  }
}

export const useUpdateFormSubentityProps = <
  Subentity extends FormSubentityInterface,
>(
  formEntity: FormInterface,
  updatedSubentity: Subentity,
) => {
  const updateEntity = useUpdateEntity<FormInterface>()

  return (updatedProps: Partial<Subentity>) => {
    updateEntity({
      ...formEntity,
      subEntities: formEntity.subEntities.map(subentity =>
        subentity.id === updatedSubentity.id
          ? { ...subentity, ...updatedProps }
          : subentity,
      ),
    })
  }
}
